import {
	Box,
	Button,
	Typography,
	Skeleton,
	Stack,
	Paper,
	Card,
	CardActionArea,
	CardContent,
	Divider,
	IconButton,
	Checkbox,
	TableRow,
	TableCell,
	TableContainer,
	Table,
	TableBody,
	TableHead,
	Tooltip,
} from "@mui/material";

import CheckCircleOutlineRounded from "@mui/icons-material/CheckCircleOutlineRounded";

import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent, {
	timelineOppositeContentClasses,
} from "@mui/lab/TimelineOppositeContent";

import ActionItemTableBody from "components/ActionItemTableBody";

import format from "date-fns/format";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const ActionItemsColumn = () => {
	const token = useSelector((state) => state.auth.token);
	const currentWorkspaces = useSelector(
		(state) => state.auth.user?.currentWorkspaces
	);

	const [actionItems, setActionItems] = useState({});
	const [noteNames, setNoteNames] = useState({});
	const [checkedItems, setCheckedItems] = useState({});
	const [key, setKey] = useState({});

	const orderObjectByDate = (object) => {
		const orderedKeys = Object.keys(object).sort(
			(a, b) => new Date(a) - new Date(b)
		);
		const orderedObject = {};

		orderedKeys.forEach((key) => {
			orderedObject[key] = object[key];
		});

		return orderedObject;
	};

	useEffect(() => {
		const getActionItems = async () => {
			try {
				const response = await fetch(
					`${process.env.REACT_APP_PORT}/actionItems/getAssignedActionItems`,
					{
						method: "GET",
						headers: {
							"Content-Type": "application/json",
							Authorization: `Bearer ${token}`,
						},
					}
				);

				const data = await response.json();
				if (response.ok) {
					let newState = {};
					let newNames = {};
					let checked = {};
					const items = data.actionItems;
					items.forEach((actionItem) => {
						let dueDateObj;
						if (!newState[actionItem.dueDate])
							newState[actionItem.dueDate] = {};

						dueDateObj = newState[actionItem.dueDate];

						let fromIdArr;
						if (!dueDateObj[actionItem.fromId])
							dueDateObj[actionItem.fromId] = [];

						fromIdArr = dueDateObj[actionItem.fromId];
						fromIdArr.push(actionItem);

						newNames[actionItem.fromId] = actionItem.title;
						checked[`${actionItem.fromId}: ${actionItem.dueDate}`] = [];
					});

					console.log("new state", newState);
					newState = orderObjectByDate(newState);

					setNoteNames(newNames);
					setActionItems(newState);
					setCheckedItems(checked);
				}
			} catch (error) {
				setActionItems({});
			}
		};

		getActionItems();
	}, []);

	useEffect(() => {
		console.log("action items changed!", actionItems);
		setActionItems(actionItems);
	}, [actionItems]);

    const SkeletonGroupUpcomingActionItems = ({ number }) => {
        const skeletonGroups = [];
        for (let i = 0; i < number; i++) {
            skeletonGroups.push(
                <Box key={i} pb="2rem">
                    <Box sx={{ width: "100%", display:"flex" }} pb="0.5rem" justifyContent="center">
                        <Skeleton variant="circular" width={30} height={30} sx={{ mr:0.5, background: "linear-gradient(179.2deg, #3B57B8 -105.91%, #DCE1FF 63.24%)" }} animation={false} />
                        <Skeleton variant="circular" width={30} height={30} sx={{ mr:0.5, background: "linear-gradient(179.2deg, #3B57B8 -105.91%, #DCE1FF 63.24%)" }} animation={false} />
                        <Skeleton variant="rectangular" width={165} height={30} sx={{ borderRadius:"20px", background: "linear-gradient(179.2deg, #3B57B8 -105.91%, #DCE1FF 63.24%)" }} animation={false} />
                    </Box>
                    <Box sx={{ width: "100%", display:"flex" }} justifyContent="center">
                        <Skeleton variant="rectangular" width={230} height={150} sx={{ borderRadius:"10%", background: "linear-gradient(179.2deg, #3B57B8 -105.91%, #DCE1FF 63.24%)" }} animation={false} />
                    </Box>
                </Box>
            );
        }
    
        return <Box>{skeletonGroups}</Box>;
    };

	const handleSetAllChildrenChecked = (fromId, date, actionItems) => {
		let checked = { ...checkedItems };
		let arr = checked[`${fromId}: ${date}`] || [];

		if (arr.length === actionItems.length) {
			arr = [];
		} else
			actionItems.forEach((item) => {
				if (!arr.includes(item.item)) arr.push(item.item);
			});

		checked[`${fromId}: ${date}`] = arr;
		setCheckedItems(checked);
	};

	const handleCompleteActionItems = async (fromId, date) => {
		// grab the selected action items and create a new object with fromId and dueDate fields
		const selectedItems = checkedItems[`${fromId}: ${date}`];
		let selectedItemsObj = {};

		selectedItems.forEach((item) => {
			selectedItemsObj[item] = { item, fromId, date };
		});

		// submit them
		const response = await fetch(
			`${process.env.REACT_APP_PORT}/actionItems/completeActionItems`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify({ actionItems: selectedItemsObj }),
			}
		);

		const data = await response.json();
		console.log("data is", data);
		// on success give a notification and update the upcoming action items accordingly
		if (data?.actionItemsCompleted) {
			let newActionItems = { ...actionItems };
			data.actionItemsCompleted?.forEach((actionItem) => {
				const newArr = newActionItems[actionItem.dueDate][
					actionItem.fromId
				]?.filter((item) => item.item !== actionItem.item);
				if (newArr.length === 0)
					delete newActionItems[actionItem.dueDate][actionItem.fromId];
				else newActionItems[actionItem.dueDate][actionItem.fromId] = newArr;

				if (Object.values(newActionItems[actionItem.dueDate]).length === 0)
					delete newActionItems[actionItem.dueDate];
			});

			setActionItems(newActionItems);
		}
	};

    return (
        <Card
            raised
            gap="1rem"
            sx={{ 
                height: "500px", 
                width: "100%",
                display: "flex", 
                flexDirection: "column", 
                overflowY: "auto",
                borderRadius: "35px"
            }}
        >
            <CardContent>
                <Box borderRadius="10px" sx={{ p: "1rem", height: "100%", overflowY: "auto", background: "white" }}>
                    <Typography variant="h3" fontWeight="bold" sx={{ display: "flex", alignItems: "center", justifyContent: "center", color: "#3B57B8" }}>Upcoming Action Items</Typography>
                    <Timeline
                        sx={{
                            [`& .${timelineOppositeContentClasses.root}`]: {
                                flex: 0.2,
                            },
                            width: "100%",
                            display: "flex",
                            justifyContent: "start"
                        }}
                    >
                        {Object.entries(actionItems)?.length === 0 && (
                            <>
                                <Typography variant="h4" fontWeight="bold" color="#3B57B8" sx={{ textAlign: "center", mb: "2rem", mx: "1rem" }}>
                                    No upcoming action items! You're all caught up!
                                </Typography>
                                <SkeletonGroupUpcomingActionItems number={3} />
                            </>
                        )}
                        {Object.entries(actionItems)?.length > 0 && Object.entries(actionItems)?.map((entry, i) => {
                            const date = entry[0];
                            const actionItemArr = entry[1];

                            if (Object.values(actionItemArr).length > 0) {
                                return (
                                    <TimelineItem key={date} width="100%">
                                        <TimelineOppositeContent sx={{ flex: "none" }}>
                                            <Typography color="#3B57B8">
                                                {format(new Date(date), 'MMM dd, yyyy')}
                                            </Typography>
                                        </TimelineOppositeContent>
                                        <TimelineSeparator>
                                            <TimelineDot />
                                            {i !== Object.values(actionItems).length - 1 && <TimelineConnector sx={{ bgcolor: 'primary.main' }}/>}
                                        </TimelineSeparator>

                                        <TimelineContent width="100%">
                                            {Object.entries(actionItemArr)?.map((val) => {
                                                const fromId = val[0];
                                                const actionItemsFromId = val[1];

                                                return (
                                                    <Card raised sx={{ mb: "1rem", maxWidth: "350px", overflow: "auto", borderRadius: "10px" }}>
                                                        <CardActionArea disableTouchRipple>
                                                            <TableContainer component={Paper}>
                                                                <Table disableTouchRipple aria-label="simple table" sx={{ maxWidth: "300px" }}>
                                                                    {/* Table Header */}
                                                                    <TableHead>
                                                                        <TableRow sx={{ maxWidth: "350px", ml: "1rem" }}>
                                                                            <TableCell>
                                                                                <Tooltip title={"Select all action items"}>
                                                                                    <Checkbox
                                                                                        color="primary"
                                                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 15, margin: 0.01 } }}
                                                                                        checked={checkedItems[`${fromId}: ${date}`].length === actionItemsFromId.length}
                                                                                        indeterminate={
                                                                                            checkedItems[`${fromId}: ${date}`].length > 0 &&
                                                                                            checkedItems[`${fromId}: ${date}`].length < actionItemsFromId.length
                                                                                        }
                                                                                        onClick={() => handleSetAllChildrenChecked(fromId, date, actionItemsFromId)}
                                                                                    />
                                                                                </Tooltip>
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <Box sx={{ maxWidth: '150px', overflowX: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                                    <Typography variant="tableHeader" fontWeight="bold">
                                                                                        {noteNames[fromId] || 'Untitled'}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {checkedItems[`${fromId}: ${date}`].length > 0 ? (
                                                                                    <Tooltip title={
                                                                                        checkedItems[`${fromId}: ${date}`].length === 1 ? `Complete 1 action item` : `Complete ${checkedItems[`${fromId}: ${date}`].length} action items`
                                                                                    }>
                                                                                        <IconButton onClick={() => handleCompleteActionItems(fromId, date)}>
                                                                                            <CheckCircleOutlineRounded sx={{ fontSize: 15, margin: 0.01 }} />
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                ) : (
                                                                                    <IconButton disabled>
                                                                                        <CheckCircleOutlineRounded sx={{ fontSize: 15, margin: 0.01 }} />
                                                                                    </IconButton>
                                                                                )}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </TableHead>

                                                                    {/* Table Body */}
                                                                    <ActionItemTableBody 
                                                                        actionItemsFromId={actionItemsFromId}
                                                                        fromId={fromId}
                                                                        date={date}
                                                                        checkedItems={checkedItems}
                                                                        setCheckedItems={setCheckedItems}
                                                                    />
                                                                </Table>
                                                            </TableContainer>
                                                        </CardActionArea>
                                                    </Card>
                                                ); 
                                            })}
                                        </TimelineContent>
                                    </TimelineItem>
                                )
                            }
                        })}
                    </Timeline>
                </Box>
            </CardContent>
        </Card>
    );
};

export default ActionItemsColumn;
